/** Shopify CDN: Minification failed

Line 13:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 14:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 18:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 22:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 25:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 26:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 32:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 34:6 Transforming const to the configured target environment ("es5") is not supported yet

**/
class ProductSingle extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.slider = this.querySelector('.js-product-slider');
  }

  updateMedia() {
    if (!this.slider || !this._variant.featured_media) return;

    const mediaId = this._variant.featured_media.id;
    const slide = this.querySelector(
      `.media-gallery__item[data-media-id="${mediaId}"]`,
    );

    if (!slide) return;

    const slideId = slide.getAttribute('data-slide-id');
    if (typeof $ === 'function') {
      const slider = $(this.slider);

      slider.slick('slickGoTo', slideId);
    } else {
      this.slider.setAttribute('data-slide-id', slideId);
    }
  }

  set variant(variant) {
    this._variant = variant;
    this.updateMedia();
  }

  get variant() {
    return this._variant;
  }
}
customElements.define('product-single', ProductSingle);
